'use client';

import { type ReactElement, cloneElement, forwardRef, isValidElement, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellRootContext } from './context/upsell-root.context';
import { upsellActionStyles } from './styles/upsell-action.styles';
import type { UpsellActionPropsInterface } from './types/upsell-action.types';

/**
 * @since 10.0.0
 */
export const UpsellAction = forwardRef<HTMLDivElement, UpsellActionPropsInterface>(
  (props: UpsellActionPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellRootContext);
    const styles = css(upsellActionStyles, cssProp);
    const onImpact = tone && ['hero', 'impact'].includes(tone);
    const content = isValidElement(children)
      ? cloneElement(children as ReactElement, { onImpact })
      : null;
    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Upsell.Action"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {content}
      </div>
    );
  },
);

UpsellAction.displayName = 'Upsell.Action';
